import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const MuiSelectedListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 280px;

  .mui-label {
    color: ${COLORS.cirrus_black10};
    line-height: 20px;
    margin-bottom: 8px;
    &.disabled {
      color: ${COLORS.cirrus_black5};
    }
  }

  .asterisk {
    color: ${COLORS.cirrus_red};
  }
  .mui-select {
    border-color: ${COLORS.cirrus_black4};
    border-radius: 8px;
    background-color: ${COLORS.cirrus_black1};
    color: ${COLORS.cirrus_black};
    & fieldset {
      border-color: ${COLORS.cirrus_black4};
    }
    &:hover fieldset {
      border-color: ${COLORS.cirrus_black};
    }

    &:focus-within fieldset,
    &.Mui-focused fieldset,
    &.MuiSelect-outlined.MuiSelect-outlined.Mui-focused fieldset {
      border-color: ${COLORS.cirrus_black};
      border-width: 1px;
    }

    &.Mui-error {
      fieldset {
        border: 2px solid ${COLORS.cirrus_red};
      }
    }
    .MuiSelect-iconOutlined {
      width: 32px;
      height: 27px;
      color: ${COLORS.primary_light_blue};
      margin-right: 4px;
    }
  }

  .MuiInputBase-input {
    padding: 13px 16px;
  }

  .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input
    .MuiTypography-root {
    box-sizing: border-box;
    color: ${COLORS.cirrus_black};
    line-height: 22px;
  }
`;

export const searchWithInputStyle = {
  maxHeight: "300px",
  overflowY: "auto",
  marginTop: "6px",
  border: "1px solid var(--color-border)",
  borderRadius: "8px",
  padding: "4px",

  ".item-wrapper": {
    width: "100%",
    display: "flex",
    alignItems: "center",
    cursor: "default",
    listStyle: "none",

    ".MuiListItemText-root": {
      margin: "0px",
      padding: "16px 0px 14px 14px",
      ".MuiTypography-root": {
        lineHeight: "19px",
        fontSize: "var(--font-size-h3)",
        fontWeight: "var(--font-weight-h3)",
        fontFamily: "var(--font-family-primary)",
        color: "var(--cirrus_black)",
      },
    },
    ".MuiIconButton-root": {
      marginRight: "10px",
    },
  },

  "& > ul:first-of-type > div:first-of-type > div:first-of-type": {
    marginTop: "0px",
    ".mui-text-field": {
      height: "48px",
    },
  },

  "& .MuiMenuItem-root": {
    wordBreak: "break-word",
    whiteSpace: "normal",
    overflowWrap: "break-word",
    padding: "0px",
  },
  "& .MuiList-root": {
    padding: "0px",
  },
};

export const SelectSearchInputWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: ${COLORS.cirrus_white};
  margin: 6px 8px;
  .select-search-input {
    .MuiOutlinedInput-root {
      border-radius: 8px;
    }
    .MuiInputAdornment-root {
      margin: 0;
      color: ${COLORS.primary_light_blue};
    }
  }
`;
